import {
    lucidePlay,
    lucideAntenna,
    lucideAsterisk,
    lucideBaby,
    lucideBan,
    lucideBuilding,
    lucideChurch,
    lucideCross,
    lucideFactory,
    lucideFlaskConical,
    lucideHospital,
    lucideHotel,
    lucideHouseHeart,
    lucideLandmark,
    lucideSquareParking,
    lucideSquareUser,
    lucideStore,
    lucideTheater,
    lucideTrainFront,
    lucideUniversity,
    lucideUtensils,
    lucideWarehouse,
    lucideWavesLadder,
    lucideActivity,
    lucideArrowDown,
    lucideArrowUp,
    lucideArrowLeft,
    lucideArrowLeftToLine,
    lucideArrowRight,
    lucideArrowRightToLine,
    lucideArrowRightLeft,
    lucideArrowUpRight,
    lucideAtSign,
    lucideBadgeDollarSign,
    lucideBlocks,
    lucideBot,
    lucideBookOpen,
    lucideBookOpenText,
    lucideBrickWall,
    lucideBriefcaseBusiness,
    lucideIdCardLanyard,
    lucideCalendar,
    lucideCalendarArrowUp,
    lucideCalendarCheck2,
    lucideBell,
    lucideBuilding2,
    lucideCalendarClock,
    lucideCalendarDays,
    lucideCalendarOff,
    lucideCalendarPlus,
    lucideCalendarX,
    lucideCalendarX2,
    lucideCaptions,
    lucideCheck,
    lucideCheckCircle2,
    lucideCheckSquare,
    lucideChevronDown,
    lucideChevronLeft,
    lucideChevronRight,
    lucideChevronUp,
    lucideChevronsDownUp,
    lucideChevronsUpDown,
    lucideClock3,
    lucideClockAlert,
    lucideCircleAlert,
    lucideCircleCheck,
    lucideCircleCheckBig,
    lucideCircleHelp,
    lucideCircleQuestionMark,
    lucideCircleX,
    lucideClipboardCheck,
    lucideClipboardPen,
    lucideCloudCheck,
    lucideCloudSync,
    lucideCloudUpload,
    lucideCog,
    lucideConstruction,
    lucideCopy,
    lucideCreditCard,
    lucideCrown,
    lucideDatabase,
    lucideDownload,
    lucideDoorOpen,
    lucideDraftingCompass,
    lucideDroplets,
    lucideEllipsisVertical,
    lucideEye,
    lucideEyeOff,
    lucideExternalLink,
    lucideFile,
    lucideFileKey,
    lucideFileCheck2,
    lucideFileClock,
    lucideFileSpreadsheet,
    lucideFileText,
    lucideFingerprint,
    lucideFilterX,
    lucideFlag,
    lucideFlame,
    lucideFolder,
    lucideFolderArchive,
    lucideFolderOpen,
    lucideForklift,
    lucideGlobe,
    lucideGripVertical,
    lucideHand,
    lucideHardDrive,
    lucideHeartPulse,
    lucideHistory,
    lucideHouse,
    lucideImport,
    lucideImage,
    lucideInbox,
    lucideInfo,
    lucideGrid2X2,
    lucideLayoutDashboard,
    lucideLayoutGrid,
    lucideLandPlot,
    lucideLayers3,
    lucideLeaf,
    lucideLibraryBig,
    lucideLightbulb,
    lucideList,
    lucideListFilter,
    lucideListTodo,
    lucideLocateFixed,
    lucideLock,
    lucideLockKeyhole,
    lucideLogOut,
    lucideMail,
    lucideMap,
    lucideMapPin,
    lucideMapPinned,
    lucideMaximize,
    lucideMegaphone,
    lucideMessageCircle,
    lucideMic,
    lucideMinimize,
    lucideMinus,
    lucideMoveUp,
    lucideNotebookTabs,
    lucidePanelLeft,
    lucidePanelsTopLeft,
    lucidePencil,
    lucidePhone,
    lucidePlus,
    lucidePrinter,
    lucideQrCode,
    lucideRefreshCw,
    lucideRotateCw,
    lucideRows3,
    lucideSave,
    lucideScan,
    lucideScale,
    lucideScroll,
    lucideSearch,
    lucideSearchX,
    lucideSend,
    lucideSettings,
    lucideSettings2,
    lucideShapes,
    lucideShare2,
    lucideShieldCheck,
    lucideShieldUser,
    lucideSignal,
    lucideSignalLow,
    lucideSignalMedium,
    lucideShoppingBag,
    lucideSlidersHorizontal,
    lucideSortAsc,
    lucideSortDesc,
    lucideSnowflake,
    lucideSparkle,
    lucideSparkles,
    lucideStar,
    lucideSubtitles,
    lucideTag,
    lucideTelescope,
    lucideTrash2,
    lucideTrendingDown,
    lucideTrendingUp,
    lucideTrees,
    lucideTriangleAlert,
    lucideUnlock,
    lucideUpload,
    lucideUndo2,
    lucideUser,
    lucideUserPlus,
    lucideUsers,
    lucideWandSparkles,
    lucideWrench,
    lucideX,
    lucideZap,
    lucideZoomIn,
    lucideZoomOut,
    lucideSquareDashed,
} from '@ng-icons/lucide';
import { QPX_BUILDING_DATAPOINT_ICONS } from './building-datapoint-icons';
import {
    qpxSharepoint,
    qpxOneDrive,
    qpxDropbox,
    qpxGoogleDrive,
    qpxProcore,
} from './product-icons';
import { QPX_SUB_PREMISE_ICONS } from './sub-premise-icons';

// Upstream Lucide fallbacks: @ng-icons/lucide 33.2.2 does not export these yet.
// https://lucide.dev/icons/credit-card-check
// https://lucide.dev/icons/credit-card-minus
const lucideCreditCardCheck = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M12.5 19H4a2 2 0 01-2-2V7a2 2 0 012-2h16a2 2 0 012 2v4"/><path d="M2 10h20"/><path d="M6 14h2"/><path d="m16 17 2 2 4-4"/></svg>`;
const lucideCreditCardMinus = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M22 13V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2h8.536"/><path d="M22 10H2"/><path d="M6 14h2"/><path d="M16 17h6"/></svg>`;

const qpxQuippy = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#173E48" style="stroke-width:var(--ng-icon__stroke-width, 2)" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9" fill="#F4F1E9" /><path d="M2 15h2m16 0h2" /><rect x="7" y="11" width="10" height="8" rx="2" fill="#173E48" stroke="none" /><path d="M5 9a7 7 0 0 1 14 0" fill="#FFE0AA" stroke="#EF8617" /><path d="M3 9h18M12 2v3" stroke="#EF8617" /><path d="M9 14v2m6-2v2" stroke="#16A6CA" /></svg>`;

const qpxQuippyMono = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" style="stroke-width:var(--ng-icon__stroke-width, 2)" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9 M2 15h2m16 0h2 M5 9a7 7 0 0 1 14 0 M3 9h18 M12 2v3 M9 13.5v3m6-3v3"/></svg>`;

const qpxQrCodeOff = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" style="stroke-width:var(--ng-icon__stroke-width, 2)" stroke-linecap="round" stroke-linejoin="round"><path d="M8 8H4a1 1 0 0 1-1-1V3" /><rect width="5" height="5" x="16" y="3" rx="1" /><rect width="5" height="5" x="3" y="16" rx="1" /><path d="M12 7v1" /><path d="M7 12h3a2 2 0 0 0 1.414-.586" /><path d="M3 12h.01" /><path d="M12 3h.01" /><path d="M16 12h1" /><path d="M21 12v.01" /><path d="M21 16h-1" /><path d="M16 21v-3a2 2 0 0 1 .586-1.414" /><path d="M12 21v-1" /><path d="m2 2 20 20" /></svg>`;
const qpxNorthArrow = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="m13 5 6 13q1 2-1 1l-5-2q-1-.5-2 0l-5 2q-2 1-1-1l6-13q1-2 2 0Z"/></svg>`;
const qpxRulerDimensionLineVertical = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M15 14h-3 M15 10h-3 M15 6h-3 M8 22H4 M6 2v20 M8 2H4 M15 18h-3"/><rect x="12" y="2" width="8" height="20" rx="2"/></svg>`;

const qpxDuplex = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M4 10 12 4l8 6v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z M12 4v17 M8 17v4 M16 17v4"/></svg>`;
const qpxBoardingHouse = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M4 9 7 4h10l3 5v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z M4 13h16 M12 17v4 M8 9h.01 M16 9h.01"/></svg>`;
const qpxCaretakerResidence = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M3 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6.2 M3 21h18V12l-4-4-5 4v9 M17 17v4 M7 7h2 M7 11h2"/></svg>`;
const qpxRetirementVillage = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M3 11l3-3 3 3v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z M15 11l3-3 3 3v6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1Z M3 22h18"/></svg>`;
const qpxShowroom = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M2 6h20 M4 6v15 M20 6v15 M4 11h16 M12 11v10 M2 21h20"/></svg>`;
const qpxShoppingCentre = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M2 21h20 M4 21V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v15 M4 10h16 M12 4v6 M9 21v-5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5"/></svg>`;
const qpxDaySurgery = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><rect x="4" y="8" width="16" height="13" rx="2"/><path d="M10 8V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4 M9 14.5h6 M12 12v5"/></svg>`;
const qpxSchool = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M3 21V11a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10 M6 9V2h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6 M10 21v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5 M2 21h20"/></svg>`;
const qpxCommunityHall = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="m2 9 10-5 10 5Z M5 9v12 M19 9v12 M2 21h20 M10 21v-6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v6"/></svg>`;
const qpxStadium = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><rect x="3" y="4" width="18" height="16" rx="5"/><rect x="8" y="8" width="8" height="8" rx="2"/></svg>`;
const qpxShedGarage = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M4 10 12 4l8 6v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z M8 21V12a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v9 M8 16h8"/></svg>`;
const qpxBushfireShelter = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="m4 13 4-7h8l4 7v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z M10 21v-7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7"/></svg>`;
const qpxBuildingComplex = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M10 12h4" /> <path d="M10 8h4" /> <path d="M14 21v-3a2 2 0 0 0-4 0v3" /> <path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2" /> <path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" /></svg>`;

export const QPX_LUCIDE_ICONS = {
    lucidePlay,
    qpxQuippy,
    qpxQuippyMono,
    qpxQrCodeOff,
    ...QPX_BUILDING_DATAPOINT_ICONS,
    ...QPX_SUB_PREMISE_ICONS,
    qpxDuplex,
    qpxBoardingHouse,
    qpxCaretakerResidence,
    qpxRetirementVillage,
    qpxShowroom,
    qpxShoppingCentre,
    qpxDaySurgery,
    qpxSchool,
    qpxCommunityHall,
    qpxStadium,
    qpxShedGarage,
    qpxBushfireShelter,
    qpxBuildingComplex,
    lucideAntenna,
    lucideAsterisk,
    lucideBaby,
    lucideBan,
    lucideBuilding,
    lucideChurch,
    lucideCross,
    lucideFactory,
    lucideFlaskConical,
    lucideHospital,
    lucideHotel,
    lucideHouseHeart,
    lucideLandmark,
    lucideSquareParking,
    lucideSquareUser,
    lucideStore,
    lucideTheater,
    lucideTrainFront,
    lucideUniversity,
    lucideUtensils,
    lucideWarehouse,
    lucideWavesLadder,

    qpxDropbox,
    qpxGoogleDrive,
    qpxNorthArrow,
    qpxOneDrive,
    qpxProcore,
    qpxRulerDimensionLineVertical,
    qpxSharepoint,
    lucideActivity,
    lucideArrowDown,
    lucideArrowUp,
    lucideArrowLeft,
    lucideArrowLeftToLine,
    lucideArrowRight,
    lucideArrowRightToLine,
    lucideArrowRightLeft,
    lucideArrowUpRight,
    lucideAtSign,
    lucideBadgeDollarSign,
    lucideBlocks,
    lucideBot,
    lucideBookOpen,
    lucideBookOpenText,
    lucideBrickWall,
    lucideBriefcaseBusiness,
    lucideIdCardLanyard,
    lucideBell,
    lucideBuilding2,
    lucideCalendar,
    lucideCalendarArrowUp,
    lucideCalendarCheck2,
    lucideCalendarClock,
    lucideCalendarDays,
    lucideCalendarOff,
    lucideCalendarPlus,
    lucideCalendarX,
    lucideCalendarX2,
    lucideCaptions,
    lucideCheck,
    lucideCheckCircle2,
    lucideCheckSquare,
    lucideChevronDown,
    lucideChevronLeft,
    lucideChevronRight,
    lucideChevronUp,
    lucideChevronsDownUp,
    lucideChevronsUpDown,
    lucideClock3,
    lucideClockAlert,
    lucideCircleAlert,
    lucideCircleCheck,
    lucideCircleCheckBig,
    lucideCircleHelp,
    lucideCircleQuestionMark,
    lucideCircleX,
    lucideClipboardCheck,
    lucideClipboardPen,
    lucideCloudCheck,
    lucideCloudSync,
    lucideCloudUpload,
    lucideCog,
    lucideConstruction,
    lucideCopy,
    lucideCreditCard,
    lucideCreditCardCheck,
    lucideCreditCardMinus,
    lucideCrown,
    lucideDatabase,
    lucideDownload,
    lucideDoorOpen,
    lucideDraftingCompass,
    lucideDroplets,
    lucideEllipsisVertical,
    lucideEye,
    lucideEyeOff,
    lucideExternalLink,
    lucideFile,
    lucideFileKey,
    lucideFileCheck2,
    lucideFileClock,
    lucideFileSpreadsheet,
    lucideFileText,
    lucideFingerprint,
    lucideFilterX,
    lucideFlag,
    lucideFlame,
    lucideFolder,
    lucideFolderArchive,
    lucideFolderOpen,
    lucideForklift,
    lucideGlobe,
    lucideGripVertical,
    lucideHand,
    lucideHardDrive,
    lucideHeartPulse,
    lucideHistory,
    lucideHouse,
    lucideImport,
    lucideImage,
    lucideInbox,
    lucideInfo,
    lucideGrid2X2,
    lucideLayoutDashboard,
    lucideLayoutGrid,
    lucideLandPlot,
    lucideLayers3,
    lucideLeaf,
    lucideLibraryBig,
    lucideLightbulb,
    lucideList,
    lucideListFilter,
    lucideListTodo,
    lucideLocateFixed,
    lucideLock,
    lucideLockKeyhole,
    lucideLogOut,
    lucideMail,
    lucideMap,
    lucideMaximize,
    lucideMapPin,
    lucideMapPinned,
    lucideMegaphone,
    lucideMessageCircle,
    lucideMic,
    lucideMinimize,
    lucideMinus,
    lucideMoveUp,
    lucideNotebookTabs,
    lucidePanelLeft,
    lucidePanelsTopLeft,
    lucidePencil,
    lucidePhone,
    lucidePlus,
    lucidePrinter,
    lucideQrCode,
    lucideRefreshCw,
    lucideRotateCw,
    lucideRows3,
    lucideSave,
    lucideScan,
    lucideScale,
    lucideScroll,
    lucideSearch,
    lucideSearchX,
    lucideSend,
    lucideSettings,
    lucideSettings2,
    lucideShapes,
    lucideShoppingBag,
    lucideShare2,
    lucideShieldCheck,
    lucideShieldUser,
    lucideSignal,
    lucideSignalLow,
    lucideSignalMedium,
    lucideSlidersHorizontal,
    lucideSortAsc,
    lucideSortDesc,
    lucideSnowflake,
    lucideSparkle,
    lucideSparkles,
    lucideStar,
    lucideSubtitles,
    lucideTag,
    lucideTelescope,
    lucideTrash2,
    lucideTrendingDown,
    lucideTrendingUp,
    lucideTrees,
    lucideTriangleAlert,
    lucideUnlock,
    lucideUpload,
    lucideUndo2,
    lucideUser,
    lucideUserPlus,
    lucideUsers,
    lucideWandSparkles,
    lucideWrench,
    lucideX,
    lucideZap,
    lucideZoomIn,
    lucideZoomOut,
    lucideSquareDashed,
} as const;
